import script from "./AssembleOrderPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AssembleOrderPage.vue?vue&type=script&setup=true&lang=js"

import "./AssembleOrderPage.vue?vue&type=style&index=0&id=fb19e660&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb19e660"]])

export default __exports__